<template>
  <a-drawer v-model:open="open" width="40%" placement="right">
     <template #title>
      <span class="margin-right">订单号 - {{ data.NO }}</span>
      <a-tag color="red" v-if="data.cancel">订单退货申请中</a-tag>
     </template>
     <div class="margin-bottom-lg">
      <a-steps class="margin-tb" v-model:current="data.stadus" :items="types"  ></a-steps>

      <namevalue name="金额"><span class="text-lg price">{{ data.money }}</span></namevalue>
      <namevalue name="时间">{{ data.retime }}</namevalue>
      <namevalue name="支付">
        <a-tag color="green" v-if="data.pay>0">已支付 {{ data.payno }}</a-tag>
        <a-tag color="gray" v-else>待支付</a-tag>
      </namevalue>
      <namevalue name="买方">
          <div class="flex align-center" v-if="data.user">
            <a-avatar :size="64" :src="addip(data.user.pic)"></a-avatar>
            <div class="margin-lr">
              <div>姓名：<span class="text-primary margin-bottom-sm">{{ data.user.username }}</span></div>
              <div>帐号：<span class="text-primary margin-bottom-sm">{{ data.user.userid }}</span></div>
              <div>电话：<span class="text-primary margin-bottom-sm">{{ data.user.tel }}</span></div>
            </div>
            </div>
      </namevalue>
      <namevalue name="收货信息">
         <div class="margin-bottom-sm"> 收货人：{{ data.linkname }}</div>
         <div class="margin-bottom-sm"> 地址:{{ data.linkaddress }}</div>
         <div > 电话：{{ data.linktel }}</div>
      </namevalue>
      <namevalue name="发货信息">
         {{ data.kuaidicompanly }}  {{ data.kuaidino }}
      </namevalue>
      <namevalue name="订单备注">
          {{ data.about }}
      </namevalue>
     </div>

     <a-divider orientation="left" >订购清单</a-divider>
     <a-table :dataSource="data.items" :columns="columns" :pagination="false">

     </a-table>
  </a-drawer>
</template>
<script setup lang="ts">
import api from '@/utils/http/service'
import {addip} from '@/utils/util'
import namevalue from '@/components/lanseed/namevalue.vue'
import { onMounted,ref } from 'vue';
  const data:Object=ref({})
  const open:boolean=ref(false)
  const types:Array=ref([])
  onMounted(()=>{
    api.list.status().then(res=>{
      if(res.data){
        let ass=[]
        res.data.forEach(e => {
            ass.push({title:e.text})
        })
        types.value=ass
      }
    })
  })
  const columns=[
    {
      title: '品名',
      dataIndex: 'title'
    },
    {
      title: '型号',
      dataIndex: 'mode'
    },
    {
      title: '单价',
      dataIndex: 'money'
    },
    {
      title: '数量',
      dataIndex: 'count'
    },
  ]
  const getData=(no):void=>{
    open.value=true
    api.list.getv(no).then(res=>{
      if(res.state==1){
        data.value=res.data
      }
    })
  }
  defineExpose({getData})
</script>
